const VIDEO_GALLERY_PLAYER_ID = 'video-gallery-iframe';
const DATA_VIDEO_URL = 'data-iframe-url';
const ACTIVE_VIDEO = 'video-gallery_video-list_item-active';

export const videoGallery = () => {
  let videos = [];
  let player;

  const onVideoClickHandler = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const videoUrl = e.currentTarget && e.currentTarget.getAttribute(DATA_VIDEO_URL);
    if (videoUrl && player) {
      player.src = videoUrl;
      videos.forEach(video => {
        if (video.classList.contains(ACTIVE_VIDEO)) {
          video.classList.remove(ACTIVE_VIDEO);
        }
      })
      e.currentTarget.classList.add(ACTIVE_VIDEO);
    }
  }

  const initListeners = () => {
    if (videos.length) {
      videos.forEach(video => {
        video.addEventListener('click', onVideoClickHandler);
      })
    }
  }

  const init = () => {
    videos = [...document.querySelectorAll('.video-gallery_video-list_item')];
    player = document.getElementById(VIDEO_GALLERY_PLAYER_ID);
    initListeners();
  }

  init();
}



// WEBPACK FOOTER //
// ./src/templates/components/video-gallery/video-gallery.js